import { serverURL } from "@/utils/serverURL";

export type SimilarSuggestion = {
  source: "similar";
  id: string;
  flavorId: string;
  flavorName: string;
  formulaId: number;
  formulaName: string;
  itemCount: number;
};

export type AiSuggestion = {
  source: "ai";
  id: string;
  resultId: number;
  rank: number;
  finalLossL2Sq: number | null;
  itemCount: number;
};

export type CompareSuggestionsResponse = {
  similar: SimilarSuggestion[];
  aiGenerated: AiSuggestion[];
};

export async function fetchCompareSuggestions(
  flavorId: string,
  signal?: AbortSignal,
): Promise<CompareSuggestionsResponse> {
  const res = await fetch(
    serverURL`/me/flavor/${flavorId}/compare-suggestions`,
    { credentials: "include", signal },
  );
  if (!res.ok) {
    throw new Error(
      `flavor/${flavorId}/compare-suggestions failed: ${res.status}`,
    );
  }
  return (await res.json()) as CompareSuggestionsResponse;
}
